import { render, staticRenderFns } from "./sport_team.vue?vue&type=template&id=6035db0e&"
import script from "./sport_team.vue?vue&type=script&lang=js&"
export * from "./sport_team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports